import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { useStyles, styles } from '../DailyComplianceScreenStyles';
import { Icon, Table } from 'antd';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import * as DailyComplianceActions from 'app/actions/DailyComplianceActions'
import { useState } from 'react';

const DailyComplianceTableComponent = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)

    const {
        isLoadListCompliance,
        listCompliance,
        pagination,
        filter
    } = useSelector(state => state.DailyComplianceReducer);

    const { current, pageSize, total } = pagination;

    const dataSource = listCompliance.map(
        (record) => {
            return {
                'key': record.id,
                ...record
            }
        }
    );

    const paginationTable =
    {
        defaultCurrent: 1,
        defaultPageSize: 25,
        current: current,
        pageSize: pageSize,
        total: total,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '100'],
        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let obj = {
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            column: Object.keys(sorter).length > 0 ? sorter.field : undefined,
            order: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined
        }
        dispatch(DailyComplianceActions.savePagination(obj));

        if(filter.complianceDate)
            dispatch(DailyComplianceActions.fetchDailyCompliance({
                offset: (pagination.current - 1) * pagination.pageSize,
                limit: pagination.pageSize,
                sortColumn: Object.keys(sorter).length > 0 ? sorter.field : undefined,
                sortDir: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined,
                complianceDate: filter.complianceDate
            }));
    }

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            ellipsis: true,
            width: 250
        },
        {
            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            sorter: true,
            ellipsis: true,
            width: 150
        },
        {
            title: 'Programa de comunicación',
            dataIndex: 'communicationProgramName',
            key: 'communicationProgramName',
            sorter: true,
            ellipsis: true,
            width: 250
        },
        {
            title: 'Especialidad/Sistema',
            dataIndex: 'specialtyOrSystem',
            key: 'specialtyOrSystem',
            sorter: true,
            ellipsis: true,
            width: 200
        },
        {
            title: 'Procedimiento/Material de capacitación',
            dataIndex: 'courseName',
            key: 'courseName',
            sorter: true,
            ellipsis: true,
            width: 300
        },
        {
            title: 'Tipo de capacitación',
            dataIndex: 'trainingName',
            key: 'trainingName',
            sorter: true,
            ellipsis: true,
            width: 200
        },
        {
            title: 'Fecha Evaluación Teórica',
            dataIndex: 'dateEvaluation',
            key: 'dateEvaluation',
            sorter: true,
            ellipsis: true,
            width: 250,
            render: record => {
                if (record === '---')
                    return record;
                else
                    return moment(record).locale('es').format('L')
            }
        }
    ];

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <Table
            loading={isLoadListCompliance}
            columns={columns}
            dataSource={dataSource}
            pagination={paginationTable}
            // scroll={{ y: 700, x: "min-content" }}
            scroll={{ x: 'min-content', y: (height - 420) }}
            size={"small"}
            onChange={handleTableChange}
        />
    )
}

export default DailyComplianceTableComponent;
